import classNames from 'clsx';
import type { CSSProperties } from 'react';
import { commarize } from 'shared/common/utils/number';
import { PIK_PROMO } from 'shared/map-search/constants/pik';
import { TFeaturePropertiesRequiredPrice } from 'shared/map-search/types/map';

import * as styles from './specialPromo.css';

export interface ISpecialPromoProps
  extends
    Pick<TFeaturePropertiesRequiredPrice, 'specialPromo' | 'minPrice'>,
    Partial<Pick<TFeaturePropertiesRequiredPrice, 'isActive' | 'isHovered' | 'isViewed'>> {}

export const SpecialPromo = ({ specialPromo, minPrice, isActive, isHovered, isViewed }: ISpecialPromoProps) => {
  const isPik = specialPromo?.builderId === PIK_PROMO.developerId;
  const iconStyle: CSSProperties | undefined =
    specialPromo && !isPik
      ? {
          backgroundColor: specialPromo.lightColor ?? undefined,
          backgroundImage: specialPromo.pinUrl ? `url("${specialPromo.pinUrl}")` : undefined,
        }
      : undefined;

  return (
    <div className={styles['container']} data-testid="special-promo-pin">
      <div
        className={classNames(styles['balloon'], {
          [styles['balloon--active']]: isActive,
          [styles['balloon--hovered']]: isHovered && !isActive,
          [styles['balloon--viewed']]: isViewed,
        })}
      >
        <span
          aria-hidden="true"
          className={classNames(styles['icon'], {
            [styles['icon--pik']]: isPik,
          })}
          style={iconStyle}
        />
        <span className={styles['price']}>от {commarize(minPrice)}</span>
      </div>
    </div>
  );
};
